import Swal from "sweetalert2";
import { Router } from "@angular/router";

export function showSucess(title:string,text: string, html?: string ){
    Swal.fire({
        text: text,
        title: title,
        html: html,
        icon: 'success',
        showConfirmButton: true,
        showCloseButton: true,
        confirmButtonColor:'#00A676'
    })
}

export function showError(title:string,text: string, html?: string){
    Swal.fire({
        title: title,
        text: text,
        html: html,
        showConfirmButton: true,
        showCloseButton: true,
        icon: 'error',
    })
}

export function showErrorViaArray(title:string,errors: string[], html?: string){
    const mensagem = errors.join(". ");
    Swal.fire({
        title: title,
        text: mensagem,
        html: html,
        showConfirmButton: true,
        showCloseButton: true,
        icon: 'error',
    })
}

export function showErrorAndNavigateToHome(router: Router, title:string,text: string, html?: string){
  Swal.fire({
    title: title,
    text: text,
    html: html,
    showConfirmButton: true,
    showCloseButton: true,
    icon: 'error',
  }).then((result) => {
    // Redireciona para a home quando o alerta for fechado
    if (result.isConfirmed || result.isDismissed) {
      router.navigate(["login"]);
    }
  });
}

export function showNotification(title:string,text: string, html?: string){
    Swal.fire({
        text: text,
        title: title,
        html: html,
        iconHtml: '<img style="width: 60px" src="../../../../assets/icons/report.svg" alt="">',
        showConfirmButton: true,
        showCloseButton: true,
    })
}

export function showWarning(title:string,text: string, html?: string){
    Swal.fire({
        text: text,
        title: title,
        html: html,
        icon: 'warning',
        showConfirmButton: true,
        showCloseButton: true,
    })
}

export function showDefaultError(error: string){
    Swal.fire({
        icon: 'error',
        html: error['error']['data']['detalhesErro'],
        showConfirmButton: true,
        showCloseButton: true,
    })
}
